import React from 'react';
import classNames from 'classnames';
import { Spin } from 'antd';
import { formatNumber } from '../../utils/format';

const FileTotalCount = ( props ) => {
    const { file, countKey, className } = props;

    return (
        <span className={ classNames( className ) } style={ file ? undefined : { display: 'flex' } }>
            { file ?
                <span>{ formatNumber( file[ countKey ] ) }</span>
                :
                <Spin size="small" data-testid="file-total-count-spin" />
            }
        </span>
    );
};

export default FileTotalCount;